export const AGG = 'agg';
export const PEN = 'pen';

export const AGG_BADGE = 'AGG';
export const PEN_BADGE = 'PEN';
